var React = require('react');

function Circle3 (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"Path_1215","data-name":"Path 1215","d":"M2678.384-14692.371s41.495.929,52.591,44.052-36.053,50.662-43.414,51.029-56.307,6.122-54.519-43.081S2678.384-14692.371,2678.384-14692.371Z","transform":"matrix(-0.875, 0.485, -0.485, -0.875, -4685.991, -14042.603)","fill":"none","stroke":"#fff","strokeWidth":"1"}));
}

Circle3.defaultProps = {"width":"134.825","height":"133.153","viewBox":"0 0 134.825 133.153"};

module.exports = Circle3;

Circle3.default = Circle3;
